exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".team-color {\n  display: -webkit-flex;\n  display: flex;\n  -webkit-align-items: baseline;\n          align-items: baseline;\n  -webkit-justify-content: center;\n          justify-content: center;\n}\n\n.team-color-primary {\n  display: flow-root;\n  -webkit-flex-grow: 1;\n          flex-grow: 1;\n}\n\n.team-color-secondary {\n  display: flow-root;\n  -webkit-flex-grow: 1;\n          flex-grow: 1;\n}\n\n.team-color-title {\n  width: 100%;\n  text-align: center;\n  margin-bottom: 10px;\n}\n", ""]);

// exports
